/**
 * Certificate URL utilities
 * Generate certificate verification URLs for different gemological laboratories
 */
/**
 * Generate the certificate verification URL based on the lab
 * @param lab - Laboratory name (e.g., 'GIA', 'AGS', 'IGI', etc.)
 * @param certificateNumber - Certificate number
 * @returns Certificate URL or null if lab is not supported
 */
export function getCertificateUrl(lab, certificateNumber) {
    if (!lab || !certificateNumber) {
        return null;
    }
    const labUpper = lab.toUpperCase().trim();
    const certNumber = certificateNumber.trim();
    switch (labUpper) {
        case 'GIA':
            return `https://www.gia.edu/report-check?locale=en_US&reportno=${certNumber}`;
        case 'AGS':
            return `https://www.americangemsociety.org/en/grade-check?reportno=${certNumber}`;
        case 'IGI':
            return `https://www.igi.org/verify-your-report/?r=${certNumber}`;
        case 'HRD':
            return `https://www.hrdantwerp.com/en/verify-your-certificate?certificate_number=${certNumber}`;
        case 'EGL':
        case 'EGLUSA':
        case 'EGL USA':
            return `https://www.eglusa.com/verify-a-report-results/?st_num=${certNumber}`;
        case 'GCAL':
            return `https://www.gcalusa.com/certificate-search.html?certificate_id=${certNumber}`;
        default:
            // Lab not supported or unknown
            return null;
    }
}
/**
 * Check if a certificate URL is available for a given lab
 * @param lab - Laboratory name
 * @returns True if the lab has online certificate verification
 */
export function hasCertificateUrl(lab) {
    if (!lab)
        return false;
    const labUpper = lab.toUpperCase().trim();
    const supportedLabs = ['GIA', 'AGS', 'IGI', 'HRD', 'EGL', 'EGLUSA', 'EGL USA', 'GCAL'];
    return supportedLabs.includes(labUpper);
}
/**
 * Get the display name for the certificate verification link
 * @param lab - Laboratory name
 * @returns Display text for the link
 */
export function getCertificateLinkText(lab) {
    return `View ${lab.toUpperCase()} Certificate`;
}
